import * as types from 'store/project/projectTypes'

export function fetchAllInformationForProject(payload){
    return{
        type: types.FETCH_ALL_NECESSARY_PROJECT_INFO_REQUESTED,
        payload: payload
    }
}

export function putProjectStatus(payload){
    return{
        type: types.PUT_PROJECT_STATUS_REQUESTED,
        payload: payload
    }
}

export function fetchAllDashboardInfo(payload){
    return{
        type: types.FETCH_ALL_DASHBOARD_INFO_REQUESTED,
        payload: payload
    }
}

export function updateProjectModerators(payload){
    return{
        type: types.UPDATE_PROJECT_MODERATORS_REQUESTED,
        payload: payload
    }
}

export function toggleAddModeratorsModal(payload){
    return{
        type: types.TOGGLE_ADD_MODERATORS_MODAL,
        payload: payload
    }
}

export function toggleUnableToRemoveModModal(payload){
    return{
        type: types.TOGGLE_UNABLE_TO_REMOVE_MOD_MODAL,
        payload: payload
    }
}


export function toggleTimeRangeModal(payload){
    return{
        type: types.TOGGLE_TIME_RANGE_MODAL,
        payload: payload
    }
}

export function addModeratorTimeRange (payload){
    return{
        type: types.PUT_MODERATOR_TIME_RANGE_RQUESTED,
        payload: payload
    }
}

export function fetchMarketsWithNpiNumbers(){
    return{
        type: types.FETCH_MARKETS_WITH_NPI_REQUESTED
    }
}

export function fetchProjectSurveys(){
    return{
        type: types.FETCH_PROJECT_SURVEYS_REQUESTED
    }
}

export function addConferenceLinkMeetingInfoTranslations(editedConferenceLink,editedMeetingInformationMap){
    return{
        
        type: types.POST_CONFERENCE_LINK_DETAILS_REQUESTED,
        editedConferenceLink: editedConferenceLink,
        editedMeetingInformationMap: editedMeetingInformationMap
    }
}

export function getConferenceLinkDetails(payload){
    return{
        type: types.GET_CONFERENCE_LINK_DETAILS_REQUESTED,
        payload: payload
    }
}

export function editConferenceLinkDetails(payload){
    return {
        type: types.UPDATE_CONFERENCE_LINK_DETAILS_REQUESTED,
        payload: payload
    }
}

export function toggleEditConferenceLinkModal(isOpen,editedConferenceLink,editedMeetingInformationMap){
    return {
        type: types.TOGGLE_EDIT_CONFERENCE_LINK_CONFIRMATION_MODAL,
        isOpen: isOpen,
        editedConferenceLink: editedConferenceLink,
        editedMeetingInformationMap: editedMeetingInformationMap
    }
}

export function generateSchedulerLink(payload){
    return {
        type: types.UPDATE_PROJECT_INFO_REQUESTED,
        payload: payload
    }
}

export function editSurveyId(payload){
    return {
        type: types.UPDATE_PROJECT_SURVEY_ID_REQUESTED,
        payload: payload
    }
}

export function getAvModeratorsCount(payload){
    return {
        type: types.GET_AVAILABLE_MODERATORS_COUNT_REQUESTED,
        payload: payload
    }
}

export function updateProjectSampleSize(payload){
    return {
        type: types.UPDATE_PROJECT_SAMPLE_SIZE_REQUESTED,
        payload: payload
    }
}

export function deleteProjectModerator(payload){
    return {
        type: types.DELETE_PROJECT_MODERATOR_REQUESTED,        
        payload: payload
    }
}

export function getUnavailableModerators(payload){
    return {
        type: types.GET_UNAVAILABLE_MODERATORS_REQUESTED,
        payload: payload
    }
}

export function editInterviewBuffer(payload){
    return {
        type: types.UPDATE_INTERVIEW_BUFFER_REQUESTED,
        payload: payload
    }
}

export function toggleTranslationsModal(payload,editedMeetingInformation,editedTopicName){
    return{
        type: types.TOGGLE_TRANSLATIONS_MODAL,
        payload: payload,
        editedMeetingInformation: editedMeetingInformation,
        editedTopicName: editedTopicName,
    }
}

export function addTranslations(payload){
    return{ 
        type: types.ADD_TRANSLATIONS_REQUESTED,
        payload: payload
    }
}

export function setMeetingInfromation(payload){
    return{
        type: types.SET_MEETING_INFORMATION_PER_LANGUAGE,
        payload: payload
    }
}


export function clearTranslations(payload){
    return{
        type: types.CLEAR_TRANSLATIONS,
        payload: payload
    }
}

export function deleteTranslation(payload){
    return{
        type: types.DELETE_TRANSLATIONS_REQUESTED,
        payload: payload
    }
}
export function deleteTranslationDirectly(payload){
    return{
        type: types.DELETE_TRANSLATIONS_SUCCESSED,
        payload: payload
    }
}

export function deleteTopicTransltion(payload){
    return{
        type: types.DELETE_TOPIC_TRANSLATIONS_REQUESTED,
        payload: payload
    }
}

export function toggleInconsistentMeetingInformationModal(payload){
    return{
        type: types.TOGGLE_INCONSISTENT_MEETING_INFORMATION_MODAL,
        payload: payload
    }
}

export function toggleTranslationsErrorModal(payload){
    return{
        type: types.TOGGLE_TRANSLATIONS_ERROR_MODAL,
        payload: payload
    }
}
export function toggleTopicTransltionsErrorModal(payload){
    return{
        type: types.TOGGLE_TOPIC_TRANSLATIONS_ERROR_MODAL,
        payload: payload
    }
}

export function addTopicNameTranslations(payload){
    return{
        type: types.ADD_TOPIC_NAME_TRANSLATIONS_REQUESTSED,
        payload: payload
    }
}
